module.exports = __webpack_public_path__ + "static/media/logo.ca79ca27.svg";